import { Component, ChangeDetectionStrategy, Input, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SelectComponent, SelectOptionComponent } from '@knorr-bremse-portals/ngx-components/components/controls/select';
import { InheritedControlValueAccessorComponent } from '@knorr-bremse-portals/ngx-components/internal/controls';

export interface Language {
  code: string;
  nativeName: string;
}

@Component({
  selector: 'kb-language-select',
  templateUrl: './language-select.component.html',
  styleUrls: ['./language-select.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [ CommonModule, SelectOptionComponent, SelectComponent ],
})
export class LanguageSelectComponent extends InheritedControlValueAccessorComponent<Language> {

  @ViewChild(SelectComponent, { static: true }) protected valueAccessor!: SelectComponent<Language>;

  @Input()
  public languages!: Language[];

}
